import { render, staticRenderFns } from "./PlantImageGallery.vue?vue&type=template&id=2169e6d1"
import script from "./PlantImageGallery.vue?vue&type=script&lang=ts"
export * from "./PlantImageGallery.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports